import React, { useState } from "react";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

const MaskedText = ({ text, maskChar = "＊", className = "" }) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!text) return null;

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const maskedContent = `${maskChar.repeat(6)}`;

  return (
    <div className={`d-flex align-items-center gap-2 ${className}`}>
      <div style={{ flex: 1 }}>{isVisible ? text : maskedContent}</div>
      <button
        onClick={toggleVisibility}
        type="button"
        className="btn btn-link p-0 text-dark"
      >
        {isVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
      </button>
    </div>
  );
};

export default MaskedText;
